import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-sms-smss',
  templateUrl: './sms-smss.component.html',
  styleUrls: ['./sms-smss.component.scss']
})
export class SmsSmssComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
